/* Shared canvas renderer for The Patchwork Tree seating plans.
   Used by the builder page (download/share image) and the guest
   find-my-table page (view full plan).

   window.PTSeating.renderPlan(plan, opts) -> Promise<HTMLCanvasElement>
     plan: { couple: {name1, name2}, eventDate, tables: [{name, guests: []}] }
     opts: { qrDataUrl (optional), highlightGuest (optional), width (default 1600) }

   window.PTSeating.makeQr(text, sizePx) -> data URL (PNG)   [needs pt-qrcode.js]
*/
(function () {
  var COLORS = {
    bg: '#faf7f1',
    ink: '#3d3a34',
    soft: '#6f6a5f',
    card: '#ffffff',
    line: '#e0d7c6',
    gold: '#b8965a',
    highlight: '#f3e7d0'
  };

  function loadFonts() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([
      document.fonts.load('400 80px "Great Vibes"'),
      document.fonts.load('600 40px "Cormorant Garamond"'),
      document.fonts.load('400 30px "Cormorant Garamond"')
    ]).catch(function () {});
  }

  function renderPlan(plan, opts) {
    opts = opts || {};
    var W = opts.width || 1600;
    return loadFonts().then(function () {
      // Max 12 names per box (owner's print rule): overflow continues in a
      // "(cont.)" box so screen and printed plans behave identically.
      var MAX_LINES = 12;
      var tables = [];
      (plan.tables || []).forEach(function (t) {
        var guests = t.guests || [];
        if (guests.length <= MAX_LINES) {
          tables.push(t);
          return;
        }
        for (var i = 0; i < guests.length; i += MAX_LINES) {
          tables.push({
            name: i === 0 ? t.name : t.name + ' (cont.)',
            guests: guests.slice(i, i + MAX_LINES)
          });
        }
      });
      var cols = tables.length <= 2 ? tables.length || 1 : tables.length <= 6 ? 2 : tables.length <= 12 ? 3 : 4;
      var GAP = 36;
      var PAD = 90;
      var colW = (W - PAD * 2 - GAP * (cols - 1)) / cols;

      var TITLE_H = 340;
      var FOOT_H = opts.qrDataUrl ? 300 : 140;
      var LINE_H = 44;
      var CARD_PAD = 34;
      var CARD_HEAD = 74;

      // Uniform grid: every box identical size (like the printed plans),
      // sized to the fullest table, laid out in aligned rows.
      var maxGuests = 1;
      tables.forEach(function (t) { maxGuests = Math.max(maxGuests, t.guests.length); });
      var BOX_H = CARD_HEAD + CARD_PAD * 2 + maxGuests * LINE_H;
      var placements = [];
      tables.forEach(function (t, i) {
        placements.push({
          table: t,
          col: i % cols,
          y: TITLE_H + Math.floor(i / cols) * (BOX_H + GAP),
          h: BOX_H
        });
      });
      var rowsCount = Math.ceil(tables.length / cols);
      var H = TITLE_H + rowsCount * (BOX_H + GAP) - GAP + FOOT_H;

      var canvas = document.createElement('canvas');
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');

      ctx.fillStyle = COLORS.bg;
      ctx.fillRect(0, 0, W, H);

      // Thin double border frame
      ctx.strokeStyle = COLORS.gold;
      ctx.lineWidth = 3;
      ctx.strokeRect(30, 30, W - 60, H - 60);
      ctx.lineWidth = 1;
      ctx.strokeRect(42, 42, W - 84, H - 84);

      // Header
      ctx.textAlign = 'center';
      ctx.fillStyle = COLORS.soft;
      ctx.font = '30px "Cormorant Garamond", serif';
      ctx.fillText('S E A T I N G   P L A N', W / 2, 120);

      var coupleText = plan.couple.name2
        ? plan.couple.name1 + '  &  ' + plan.couple.name2
        : plan.couple.name1;
      ctx.fillStyle = COLORS.ink;
      var scriptSize = 96;
      ctx.font = scriptSize + 'px "Great Vibes", cursive';
      while (ctx.measureText(coupleText).width > W - 260 && scriptSize > 40) {
        scriptSize -= 6;
        ctx.font = scriptSize + 'px "Great Vibes", cursive';
      }
      ctx.fillText(coupleText, W / 2, 235);

      if (plan.eventDate) {
        ctx.fillStyle = COLORS.soft;
        ctx.font = '32px "Cormorant Garamond", serif';
        ctx.fillText(plan.eventDate, W / 2, 295);
      }

      // Table cards
      var hl = (opts.highlightGuest || '').trim().toLowerCase();
      placements.forEach(function (p) {
        var x = PAD + p.col * (colW + GAP);
        var y = p.y;

        ctx.fillStyle = COLORS.card;
        ctx.strokeStyle = COLORS.line;
        ctx.lineWidth = 2;
        roundRect(ctx, x, y, colW, p.h, 14);
        ctx.fill();
        ctx.stroke();

        ctx.fillStyle = COLORS.gold;
        ctx.font = '600 40px "Cormorant Garamond", serif';
        ctx.textAlign = 'center';
        ctx.fillText(fitText(ctx, p.table.name, colW - CARD_PAD * 2), x + colW / 2, y + CARD_PAD + 30);

        ctx.strokeStyle = COLORS.line;
        ctx.beginPath();
        ctx.moveTo(x + CARD_PAD + 10, y + CARD_HEAD + 8);
        ctx.lineTo(x + colW - CARD_PAD - 10, y + CARD_HEAD + 8);
        ctx.stroke();

        ctx.font = '30px "Cormorant Garamond", serif';
        p.table.guests.forEach(function (g, i) {
          var gy = y + CARD_HEAD + CARD_PAD + 10 + i * LINE_H;
          if (hl && g.trim().toLowerCase() === hl) {
            ctx.fillStyle = COLORS.highlight;
            roundRect(ctx, x + CARD_PAD - 8, gy - 30, colW - CARD_PAD * 2 + 16, 42, 8);
            ctx.fill();
          }
          ctx.fillStyle = COLORS.ink;
          ctx.fillText(fitText(ctx, g, colW - CARD_PAD * 2), x + colW / 2, gy);
        });
      });

      // Footer: QR + credit
      var footTop = H - FOOT_H + 20;
      if (opts.qrDataUrl) {
        return drawImage(ctx, opts.qrDataUrl, W / 2 - 90, footTop, 180, 180).then(function () {
          ctx.fillStyle = COLORS.soft;
          ctx.font = '26px "Cormorant Garamond", serif';
          ctx.textAlign = 'center';
          ctx.fillText('Scan to find your table', W / 2, footTop + 218);
          ctx.font = '22px "Cormorant Garamond", serif';
          ctx.fillText('thepatchworktree.co.uk', W / 2, footTop + 252);
          return canvas;
        });
      }
      ctx.fillStyle = COLORS.soft;
      ctx.font = '22px "Cormorant Garamond", serif';
      ctx.textAlign = 'center';
      ctx.fillText('Created with love at thepatchworktree.co.uk', W / 2, H - 80);
      return canvas;
    });
  }

  function fitText(ctx, text, maxW) {
    if (ctx.measureText(text).width <= maxW) return text;
    while (text.length > 2 && ctx.measureText(text + '…').width > maxW) {
      text = text.slice(0, -1);
    }
    return text + '…';
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function drawImage(ctx, src, x, y, w, h) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () { ctx.drawImage(img, x, y, w, h); resolve(); };
      img.onerror = function () { resolve(); };
      img.src = src;
    });
  }

  function makeQr(text, sizePx) {
    // window.qrcode from pt-qrcode.js (qrcode-generator)
    var qr = window.qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    var n = qr.getModuleCount();
    var margin = 2;
    var cell = Math.floor((sizePx || 512) / (n + margin * 2));
    var size = cell * (n + margin * 2);
    var cv = document.createElement('canvas');
    cv.width = size;
    cv.height = size;
    var ctx = cv.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = '#1a1a1a';
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (qr.isDark(r, c)) ctx.fillRect((c + margin) * cell, (r + margin) * cell, cell, cell);
      }
    }
    return cv.toDataURL('image/png');
  }

  function downloadCanvas(canvas, filename) {
    canvas.toBlob(function (blob) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
    }, 'image/png');
  }

  window.PTSeating = { renderPlan: renderPlan, makeQr: makeQr, downloadCanvas: downloadCanvas };
})();
